export const CREATE_SCHEDULED_TASK_COMMENT_REQUEST = 'CREATE_SCHEDULED_TASK_COMMENT_REQUEST';
export const CREATE_SCHEDULED_TASK_COMMENT_SUCCESS = 'CREATE_SCHEDULED_TASK_COMMENT_SUCCESS';
export const CREATE_SCHEDULED_TASK_COMMENT_FAIL = 'CREATE_SCHEDULED_TASK_COMMENT_FAIL';
export const CREATE_SCHEDULED_TASK_COMMENT_RESET = 'CREATE_SCHEDULED_TASK_COMMENT_RESET';

// scheduledTaskConstants.js
export const FETCH_SCHEDULED_TASK_COMMENT_REQUEST = 'FETCH_SCHEDULED_TASK_COMMENT_REQUEST';
export const FETCH_SCHEDULED_TASK_COMMENT_SUCCESS = 'FETCH_SCHEDULED_TASK_COMMENT_SUCCESS';
export const FETCH_SCHEDULED_TASK_COMMENT_FAIL = 'FETCH_SCHEDULED_TASK_COMMENT_FAIL';
export const FETCH_SCHEDULED_TASK_COMMENT_RESET = 'FETCH_SCHEDULED_TASK_COMMENT_RESET ';